import { useEffect, useState } from 'react';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { apiError } from '../shared';
import { GeoEventCard } from './GeoEventCard';

export const GeoEventsPanel = ({ base, actor = 'dispatcher', headers, revision = 0, entryId }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const serializedHeaders = JSON.stringify(headers || {});
  useEffect(() => {
    let active = true;
    setData(null); setError('');
    axios.get(`${base}/geo-control/events`, { withCredentials: true, timeout: 15000, headers: JSON.parse(serializedHeaders) })
      .then(({ data: result }) => { if (active) setData(result); })
      .catch(e => { if (active) setError(apiError(e)); });
    return () => { active = false; };
  }, [base, actor, serializedHeaders, revision, refresh]);
  const submit = async (row, command, payload) => {
    setBusy(true); setError('');
    try {
      await axios.post(`${base}/geo-control/${row.entry_id}/${row.event.event_id}/${command}`, payload, { withCredentials: true, timeout: 15000, headers });
      setRefresh(n => n + 1); return true;
    } catch (e) { setError(apiError(e)); return false; }
    finally { setBusy(false); }
  };
  const rows = data?.rows.filter(row => (!entryId || row.entry_id === entryId) && (actor === 'dispatcher' || row.event.exception));
  return <section className="space-y-3 min-w-0" data-testid="geo-control-events-panel">
    <div className="flex flex-wrap items-center justify-between gap-3"><h2 className="text-lg font-semibold">{actor === 'dispatcher' ? 'Contrôle du lieu de pointage' : 'Exceptions de lieu'}</h2><Button variant="outline" size="sm" disabled={busy} onClick={() => setRefresh(n => n + 1)} data-testid="geo-control-events-refresh">Actualiser</Button></div>
    {error && <p role="alert" className="text-sm text-red-700" data-testid="geo-control-events-error">{error}</p>}
    {!data && !error && <p className="text-sm text-slate-500" data-testid="geo-control-events-loading">Chargement…</p>}
    {rows?.length === 0 && <p className="text-sm text-slate-500" data-testid="geo-control-events-empty">Aucun événement à afficher.</p>}
    {rows?.map(row => <GeoEventCard key={row.event.event_id} row={row} actor={actor} submit={submit} busy={busy} />)}
    {data && <details className="border-t pt-3 text-sm text-slate-600" data-testid="geo-control-deadline"><summary className="cursor-pointer" data-testid="geo-control-deadline-toggle">Convention du jour ouvré</summary><p className="pt-2" data-testid="geo-control-deadline-description">{data.deadline_convention} Le délai part de la création de l’exception, même sans motif ; les compléments ne le remettent pas à zéro. L’indication « À relancer » est calculée à l’actualisation, sans notification.</p></details>}
  </section>;
};